import { TransactionType } from '@/types';
import { StepArchetype } from './stepRun';

export enum TransactionStatus {
    Requested = 'requested',
    Succeeded = 'succeeded',
    PendingRetry = 'pendingRetry',
    RetryLimitReached = 'retryLimitReached',
    Cancelled = 'cancelled',
    Expired = 'expired',
}

export interface StepTransaction {
    id: string;
    workflowRunId: string;
    targetStepRunIds: string[];
    stepArchetype: StepArchetype;
    transactionType: TransactionType;
    status: TransactionStatus;
    triggeredBy: string;
    requestedAt: string;
    lastAttemptedAt: string;
    cancelledAt: string;
    expiredAt: string;
    finishedAt: string;
}
